import React from 'react';
import styled, { css } from 'styled-components';
import { BREAKPOINT_DESKTOP } from '../constants';

const menuTogglerConfig = {
  width: 25,
  height: 20,
  barThickness: 2,
  barSpacing: 10,
};

const MenuTogglerContainer = styled.div`
  flex-shrink: 1;
  align-self: center;
  @media ${BREAKPOINT_DESKTOP} {
    display: none;
  }
`;

const MenuTogglerButton = styled.a<{ isOpen: boolean }>`
  box-sizing: content-box;
  border: 20px solid transparent;
  border-right-width: 29px;
  width: ${menuTogglerConfig.width}px;
  height: ${menuTogglerConfig.height}px;
  margin: 0 auto;
  transform: rotate(0deg);
  transition: 0.5s ease-in-out;
  cursor: pointer;
  display: block;
  ${(props) =>
    props.isOpen &&
    css`
      & span {
        &:nth-child(1) {
          top: ${menuTogglerConfig.barSpacing}px;
          width: 0%;
          left: 50%;
        }
        &:nth-child(2) {
          transform: rotate(45deg);
        }
        &:nth-child(3) {
          transform: rotate(-45deg);
        }
        &:nth-child(4) {
          top: ${menuTogglerConfig.barSpacing}px;
          width: 0%;
          left: 50%;
        }
      }
    `};
  & span {
    display: block;
    position: absolute;
    height: ${menuTogglerConfig.barThickness}px;
    width: 100%;
    background: #000;
    opacity: 1;
    left: 0;
    transform: rotate(0deg);
    transition: 0.25s ease-in-out;
    &:nth-child(1) {
      top: 0px;
    }
    &:nth-child(2),
    &:nth-child(3) {
      top: ${menuTogglerConfig.barSpacing}px;
    }
    &:nth-child(4) {
      top: ${menuTogglerConfig.barSpacing * 2}px;
    }
  }
`;

const MenuToggler: React.SFC<any> = ({ isOpen, onClick }) => {
  return (
    <MenuTogglerContainer>
      <MenuTogglerButton isOpen={isOpen} onClick={onClick}>
        <span />
        <span />
        <span />
        <span />
      </MenuTogglerButton>
    </MenuTogglerContainer>
  );
};

export default MenuToggler;



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/Header/components/MenuToggler.tsx